const SignInAppBehaviorIds = {
    childrenSwitchRoom: 'CHILDREN_SWITCH_ROOM_IN_SIGNIN_APP',
    limitedData: 'LIMIT_DATA_IN_SIGNIN_APP',
    WhiteLabelInfo: 'WhiteLabelInfo',
    enableEmployeeCheckin: 'ENABLE_EMPLOYEE_CHECKIN',
};

export default SignInAppBehaviorIds;
